<template>
  <nuttrema-menu-list theme="sidebar-menu">

    <nuttrema-menu-list-item>
      <el-popover
        ref="popover-options"
        placement="right"
        width="240"
        trigger="click">
        <nuttrema-menu-list theme="popover-nav">
          <nuttrema-menu-list-item>
            <p class="list-item-label">{{ $t('label.dashboard_settings') }}</p>
          </nuttrema-menu-list-item>
          <section>

            <nuttrema-menu-list-item>
              <div class="list-item-link">
                <div class="is-control">
                  <span>{{ $t('label.system_notices') }}</span>
                  <switch-small
                      class="switch-small"
                      v-model="options.systemNotices"
                     :disabled="true"
                     @change="handleOptionsChange">
                  </switch-small>
                </div>
              </div>
            </nuttrema-menu-list-item>

            <nuttrema-menu-list-item>
              <div class="list-item-link">
                <div class="is-control">
                  <span>{{ $t('label.video_tutorials') }}</span>
                  <switch-small
                       class="switch-small"
                       v-model="options.videoTutorials"
                      @change="handleOptionsChange">
                  </switch-small>
                </div>
              </div>
            </nuttrema-menu-list-item>

            <nuttrema-menu-list-item>
              <div class="list-item-link">
                <div class="is-control">
                  <span>{{ $t('label.tweets') }}</span>
                  <switch-small
                       class="switch-small"
                       v-model="options.tweets"
                      @change="handleOptionsChange">
                  </switch-small>
                </div>
              </div>
            </nuttrema-menu-list-item>
          </section>

          <nuttrema-menu-list-item>
            <p class="list-item-label">{{ $t('label.we_are_working_on') }}</p>
          </nuttrema-menu-list-item>
          <section>
            <nuttrema-menu-list-item>
              <div class="list-item-link">
                <div class="is-control">
                  <span>{{ $t('label.blog') }}</span>
                  <switch-small
                       class="switch-small"
                       v-model="options.blog"
                     :disabled="true"
                     @change="handleOptionsChange">
                  </switch-small>
                </div>
              </div>
            </nuttrema-menu-list-item>

            <nuttrema-menu-list-item>
              <div class="list-item-link">
                <div class="is-control">
                  <span>{{ $t('label.statistics') }}</span>
                  <switch-small
                       class="switch-small"
                       v-model="options.statistics"
                      :disabled="true"
                      @change="handleOptionsChange">
                  </switch-small>
                </div>
              </div>
            </nuttrema-menu-list-item>

            <nuttrema-menu-list-item>
              <div class="list-item-link">
                <div class="is-control">
                  <span>{{ $t('label.messages') }}</span>
                  <switch-small
                       class="switch-small"
                       v-model="options.messages"
                      :disabled="true"
                      @change="handleOptionsChange">
                  </switch-small>
                </div>
              </div>
            </nuttrema-menu-list-item>

          </section>
        </nuttrema-menu-list>

        <nuttrema-iconica-sidebar-link
           slot="reference"
           icon="far fa-sliders-v"
          :title="$t('label.dashboard_settings')">
        </nuttrema-iconica-sidebar-link>
      </el-popover>
    </nuttrema-menu-list-item>

  </nuttrema-menu-list>
</template>

<script>
import { get, clone } from 'lodash';
import { mapActions } from 'vuex';

import NuttremaMenuList from 'components/ui/navigation/nuttrema-menu-list';
import NuttremaMenuListItem from 'components/ui/navigation/nuttrema-menu-list-item';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import SwitchSmall from 'components/ui/switch/switch-small';

export default {
  name: 'cmpt-dashboard-settings',
  components: {
    SwitchSmall,
    NuttremaMenuList,
    NuttremaMenuListItem,
    NuttremaIconicaSidebarLink,
  },
  data() {
    return {
      activeColor: '#ffc107',
      inactiveColor: '#b4bccc',
      options: {
        blog: null,
        tweets: null,
        messages: null,
        statistics: null,
        systemNotices: null,
        videoTutorials: null,
      },
    };
  },
  computed: {
    DashboardSettings() {
      return this.$store.getters.DashboardSettings;
    },
  },
  methods: {
    ...mapActions([
      'SetDashboardSettings',
    ]),
    closePopover() {
      this.$refs['popover-options'].doClose();
    },
    handleOptionsChange() {
      this.SetDashboardSettings({ options: this.options });
    },
  },
  mounted() {
    const options = get(this.DashboardSettings, 'data');
    if (options) this.options = clone(options);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/home/cmpt-dashboard-settings.vue